import {ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef} from "@angular/core";
import {NgClass} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {TouchableDirective} from '../../ui-elements/touchable.directive';
import {ActivatableDirective} from '../../ui-elements/activatable.directive';

@Component({
    selector: "woa-link",
    templateUrl: "./link.component.html",
    styleUrl: "./link.component.scss",
    imports: [
        NgClass,
        TouchableDirective,
        TranslateModule,
        ActivatableDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkComponent {
    public readonly link: InputSignal<string> = input.required<string>();

    public readonly label: InputSignal<string> = input<string>();
    public readonly postscript: InputSignal<string> = input<string>();
    public readonly translationParams: InputSignal<Record<string, string | number>> = input<Record<string, string | number>>({});
    public readonly underlined: InputSignal<boolean> = input<boolean>(true);
    public readonly disabled: InputSignal<boolean> = input<boolean>(false);
    public readonly negative: InputSignal<boolean> = input<boolean>(false);
    public readonly plain: InputSignal<boolean> = input<boolean>(false);

    public onActivate: OutputEmitterRef<MouseEvent> = output<MouseEvent>();

    public activate(event: MouseEvent): void {
        this.onActivate.emit(event);
    }
}
